import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';

import {postLoanRequest} from './postLoanRequest';

interface UsePostLoanRequestProps {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ErrorResponse>) => void;
}

const usePostLoanRequest = ({
  onSuccess,
  onError,
}: UsePostLoanRequestProps = {}) => {
  const {mutate, isLoading} = useMutation({
    mutationFn: () => postLoanRequest(),

    onSuccess: () => {
      onSuccess?.();
    },

    onError: (error: AxiosError<ErrorResponse>) => {
      onError?.(error);

      const status = error.response?.status;

      if (status === 400) {
        const errorCode = error.response?.data?.error_code;

        if (errorCode) {
          toast.error(getPersianErrorCode(errorCode));

          return;
        }
      }
    },
  });

  return {mutate, isLoading};
};

export default usePostLoanRequest;
